import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * All of the route parameters used in our routes
 *
 * __NOTE:__ a prefix of `:` must be put in front of each {@link RouteParam}
 * when registering routes
 */
export enum RouteParam {
  TenantAlias = 'tenantAlias',
  ZoneAlias = 'zoneAlias',
  AppAlias = 'appAlias',
  AppPageAlias = 'appPageAlias',
  TenantId = 'tenantId',
  ZoneId = 'zoneId',
  AppId = 'appId',
  AppPageId = 'appPageId',
  ScenarioId = 'scenarioId',
}
// Needs to be before namespace is defined
const PATH_PARAMS: ReadonlySet<RouteParam> = new Set(
  Object.values(RouteParam) as RouteParam[],
)
export namespace RouteParam {
  export const ALL: readonly RouteParam[] = Array.from(PATH_PARAMS)
  export const isRouteParam = TypeChecker.Factory.oneOf(PATH_PARAMS)
  export const assertIsRouteParam: TypeAsserter<RouteParam> =
    TypeAsserter.Factory.from(isRouteParam)
}
